import React from 'react';
import {IdpEventLogList} from "components/idp-event-log/IdpEventLogList";
import {Provider} from "components/idp-event-log/IdpEventLogContext";

export const IdpEventLogs = () => {

    return (
        <Provider>
            <IdpEventLogList/>
        </Provider>
    );
}
